import { ERROR_RESPONSE } from "../codeResponses/codes";
import { Toast } from "../../components/UI/toast/Toast";

// HO-TASK-297: respuesta del backend cuando se supera el rate limit
// (HO-TASK-295): HTTP 429 con { code: "H0044", message, retry_after }.
export const TOO_MANY_REQUESTS_MESSAGE =
  "Hiciste demasiadas solicitudes seguidas. Espera un momento e intenta de nuevo.";

// Una pantalla con varias peticiones rechazadas no debe mostrar un aviso por
// cada una: como máximo uno cada 5 segundos.
const NOTICE_INTERVAL_MS = 5000;
let lastNoticeAt = 0;

export const isTooManyRequests = (data) =>
  data?.code === ERROR_RESPONSE.TOO_MANY_REQUESTS;

const retryAfterFromHeader = (response) => {
  const seconds = Number(response.headers?.get("Retry-After"));
  return seconds > 0 ? seconds : null;
};

/**
 * Lee el cuerpo JSON de una respuesta. Si es un 429, lo devuelve siempre con
 * la forma de H0044, venga de donde venga:
 * - del backend con HO-TASK-295: ya trae code, message y retry_after;
 * - del backend sin HO-TASK-295: { message: "Too Many Attempts." };
 * - de nginx o Cloudflare: una página HTML, que no se puede leer como JSON.
 */
export const readJsonResponse = async (response) => {
  if (response.status !== 429) {
    return response.json();
  }

  let data = null;
  try {
    data = await response.json();
  } catch {
    // Cuerpo HTML de nginx o Cloudflare.
  }

  if (isTooManyRequests(data)) {
    return data;
  }

  return {
    ...data,
    code: ERROR_RESPONSE.TOO_MANY_REQUESTS,
    message: TOO_MANY_REQUESTS_MESSAGE,
    retry_after: data?.retry_after ?? retryAfterFromHeader(response),
  };
};

export const notifyTooManyRequests = (data) => {
  const now = Date.now();
  if (now - lastNoticeAt < NOTICE_INTERVAL_MS) {
    return;
  }
  lastNoticeAt = now;

  Toast.fire({
    type: "error",
    title: data?.message || TOO_MANY_REQUESTS_MESSAGE,
    timer: NOTICE_INTERVAL_MS,
  });
};
